import React from "react";
import { DATE_FORMATS, ENTITY_TYPE, OBSERVATION_STATUS } from "src/shared/config/src";
import { Observation } from "src/shared/types/src/";
import { dateFormatter } from "src/shared/utils/src";
import LocalImages from '../static';
import TagListRenderer from "./commonComponents/TagListRenderer";
import MediaCollageContainer from "./commonComponents/mediaCollage/MediaCollageContainer";
import InlineMediaCollageContainer from "./commonComponents/mediaCollage/InlineMediaCollageContainer";
import WarningStatusTag from "./commonComponents/statusTags/WarningStatusTag";
import LikeCommentFooter from "./LikeCommentFooter";
import TextRenderer from "./commonComponents/TextRenderer";
import { AppRoutes } from "../navigation/routes";
import { useNavigate } from "react-router-dom";
import { TimelineActions } from "src/shared/redux-state/src/lib/timeline/TimelineSlice";
import { useAppDispatch } from "../services/store";
// import LikeCommentFooter from "./LikeCommentFooter";
// import MediaCollageContainer from "./mediaCollage/MediaCollageContainer";
// import InlineMediaCollageContainer from "./mediaCollage/InlineMediaCollageContainer";
// import WarningStatusTag from "./statusTags/WarningStatusTag";s

type IProps = {
	details: Observation,
	title?: string,
	isHomeScreenCard?: boolean
}

const ObservationCardInternalDetails: React.FC<IProps> = ({ details, title, isHomeScreenCard = false }) => {

	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const handleLikeUnlike = async ({ likeCount, likedBySelf } : {likeCount: number, likedBySelf: boolean}) => {
		// update the local observation details state and redux in timeline
		const updatedObservationDetails: Observation = { ...details, likes: { ...details.likes, count: likeCount, likedByMe: likedBySelf } };
		await dispatch(TimelineActions.updateObservationDetailsInTimeline({ observation: updatedObservationDetails }));
	}
	
	const navigateToDetailScreen = () => {
		navigate(AppRoutes.OBSERVATION_DETAILS_SCREEN(details?.id), { state: { observationDetails: details } })
	}

	return (
		<>
			<div className="d-flex align-items-center">
				<div className="section-with-img flex-1 pd-r-15">
					<div className="section-img">
						<img src={LocalImages.observationCardIcon} alt="observationCardIcon" />
					</div>
					<span className="fs-12 fw-semibold text-black flex-1 pd-l-10">{title ?? 'Observation'}</span>
				</div>
				<div className="fs-12 text-gray-300">
					{(isHomeScreenCard) ? `${details.timestampHuman}` : dateFormatter(details?.timestamp, DATE_FORMATS.TIME_AMPM)}
				</div>
			</div>

			{
				details?.tags?.length > 0 ?
					<TagListRenderer tags={details?.tags} /> : null
			}
			{
				(details?.media?.length > 0 && !isHomeScreenCard) ?
					<div className="mg-t-13">
						<MediaCollageContainer media={details.media} onMediaGroupClick={() => navigate(AppRoutes.OBSERVATION_DETAILS_SCREEN(details?.id), { state: { observationDetails: details } })} />
					</div>
					: null
			}
			{
				(details?.media?.length > 0 && isHomeScreenCard) ?
					<div className="mg-t-15">
						<InlineMediaCollageContainer media={details?.media} />
					</div> : null
			}
			{isHomeScreenCard ?
				<p className="fs-12 text-black mb-0 mg-t-15 truncate-number-3">
					<TextRenderer text={details?.content?.fieldOne?.value ?? ''} />
				</p> :
				<p className="fs-12 text-black mb-0 mg-t-15" onClick={navigateToDetailScreen}>
					<TextRenderer text={details?.content?.fieldOne?.value ?? ''} />
				</p>
			}

			{
				isHomeScreenCard ? null :
					<>
						{
							details?.status === OBSERVATION_STATUS.PENDING_NURSERY_REVIEW ?
								<div className="mg-t-10 d-flex">
									<WarningStatusTag statusString={details.status} />
								</div> :
								<LikeCommentFooter
									entityType={ENTITY_TYPE.OBSERVATION}
									entityId={details.id}
									likeCount={details?.likes?.count ?? 0}
									commentCount={details?.comments?.count ?? 0}
									likedByMe={details?.likes?.likedByMe ?? false}
									disableFooterInteraction={false} 
									onLikeUnlike={handleLikeUnlike}
									canLikeComment={details?.status === OBSERVATION_STATUS.PUBLISHED}
									showComment={true}
									disableLikeDetailsInteraction={true}
									disableCommentDetailsInteraction={true}
									onLikeDetailsPress={() => {
										navigate(AppRoutes.OBSERVATION_DETAILS_SCREEN(details?.id), { state: { observationDetails: details, openLikeDetails: true } })
									}}
									onCommentDetailsPress={() => {
										navigate(AppRoutes.OBSERVATION_DETAILS_SCREEN(details?.id), { state: { observationDetails: details, openCommentDetails: true } })
									}}
								/>
						}

					</>
			}
		</>
	)
}

export default ObservationCardInternalDetails;